import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { message, Popover } from 'antd';
import Scrollbar from 'react-scrollbars-custom';
import Util from '../../../script/util';
import AtlasDetailsModal from './AtlasDetailsModal';
import './GiftAtlas.scss';
import { DDEmpty } from '../../globalPageStatus';
import HTTP from '../../../script/service';
import AchieveItem from '../dsUserAchieve/AchieveItem';
import { debounce } from 'lodash-es';

const SORT_ORDER = ['ascend', 'descend']; // 排序字典

// 1-钻石由高到低 2-钻石由低到高 3-时间倒叙 4-时间正序 5-个数倒叙 6-个数正序

// 排序类型转换
function withSortType(sort) {
  let rankType = null;
  if (sort.field === 'price') {
    if (sort.order === 'ascend') {
      rankType = 2;
    } else if (sort.order === 'descend') {
      rankType = 1;
    }
  } else if (sort.field === 'time') {
    if (sort.order === 'ascend') {
      rankType = 4;
    } else if (sort.order === 'descend') {
      rankType = 3;
    }
  } else if (sort.field === 'num') {
    if (sort.order === 'ascend') {
      rankType = 6;
    } else if (sort.order === 'descend') {
      rankType = 5;
    }
  }

  return rankType;
}

const DEFAULT_LIMIT = 20;

class GiftAtlas extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sort: {
        field: 'price',
        order: 'ascend', // null 无 ascend 升序 descend 降序
      },
      sortList: [
        { name: '价值', type: 'price' },
        { name: '时间', type: 'time' },
        { name: '数量', type: 'num' },
      ],
      selectLevel: null, // 当前选中的等级
      lightList: ['未点亮', '点亮'],
      selectLight: null, // 当前选中的点亮
      list: [],
      current: null, // 当前选中的礼物
      pagination: {
        page: 1, // 当前页码
        limit: DEFAULT_LIMIT, // 每页条数
        is_more: true, // 是否有更多
      },
    };
  }

  componentDidMount() {
    this.getGiftList();
  }

  componentWillUnmount() {
    this.setState({ levelPopoverVisible: false });
  }

  // 获取礼物列表
  getGiftList = (payload = { page: 1, limit: DEFAULT_LIMIT }) => {
    const { ds } = this.props;
    const { sort, selectLevel, selectLight, list, pagination } = this.state;

    if (payload.page === 1) {
      pagination.is_more = true;
    }

    if (!pagination.is_more) return; // 没有更多数据了
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: true },
    });

    const rankType = withSortType(sort);
    const params = { searchUid: ds.uid, rankType };

    if (selectLevel) {
      params.level = selectLevel.level;
    }
    if (selectLight !== null) {
      params.lightStatus = selectLight;
    }
    params.page = payload.page;
    params.pageSize = payload.limit;

    HTTP._get_user_gift_wall_v3(params)
      .then((res) => {
        if (res?.code === 200) {
          let array = [];
          pagination.page = payload.page;
          pagination.limit = payload.limit;

          if (res.data?.giftItemList) {
            if (payload.page === 1) {
              this.giftAtlasScroll && this.giftAtlasScroll.scrollToTop();
              array = res.data.giftItemList;
            } else {
              array = [...list, ...res.data.giftItemList];
            }
            if (res.data.giftItemList.length < DEFAULT_LIMIT) {
              pagination.is_more = false;
            }
          }
          this.setState({ list: array, pagination });
        } else {
          message.warning(res?.message || '获取礼物列表失败，请稍后重试');
        }
      })
      .finally(() => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };

  // 选择礼物
  onSelectCurrentGift = (index) => {
    this.atlasDetailsElement.showModal(index);
  };

  // 修改排序
  onChangeSort = (item) => {
    const { sort } = this.state;
    let nextIndex = 0;
    if (item.type === sort.field) {
      const index = SORT_ORDER.indexOf(sort.order);
      nextIndex = index + 1;
      if (nextIndex > SORT_ORDER.length - 1) {
        nextIndex = 0;
      }
    }
    this.setState(
      { sort: { field: item.type, order: SORT_ORDER[nextIndex] } },
      () => {
        this.getGiftList();
      }
    );
  };

  onChangeLevel = (item) => {
    this.setState({ selectLevel: item }, () => {
      this.getGiftList();
    });
  };
  onChangeLight = (index) => {
    this.setState({ selectLight: index }, () => {
      this.getGiftList();
    });
  };

  /// 滚动翻页
  handleScroll = debounce((e) => {
    if (e.scrollHeight - (e.scrollTop + e.clientHeight) < 10) {
      const { pagination } = this.state;
      this.getGiftList({ page: pagination.page + 1, limit: pagination.limit });
    }
  }, 300);

  // 渲染等级选择弹窗
  renderPopoverContent = () => {
    const { levelTags } = this.props;
    const { selectLevel } = this.state;

    return (
      <>
        <span
          className={Util.classNames('sort-item-text', {
            active: selectLevel == null,
          })}
          onClick={() => this.onChangeLevel(null)}
        >
          全部
        </span>
        {levelTags.map((item) => (
          <span
            key={item.level}
            className={Util.classNames('sort-item-text', {
              active: item.level === selectLevel?.level,
            })}
            onClick={() => this.onChangeLevel(item)}
          >
            {item.title}
          </span>
        ))}
      </>
    );
  };
  // 渲染点亮选择弹窗
  renderLightPopoverContent = () => {
    const { lightList, selectLight } = this.state;

    return (
      <>
        <span
          className={Util.classNames('sort-item-text', {
            active: selectLight == null,
          })}
          onClick={() => this.onChangeLight(null)}
        >
          全部
        </span>
        {lightList.map((item, index) => (
          <span
            key={index}
            className={Util.classNames('sort-item-text', {
              active: index === selectLight,
            })}
            onClick={() => this.onChangeLight(index)}
          >
            {item}
          </span>
        ))}
      </>
    );
  };

  render() {
    const { base, ds } = this.props;
    const { atlasLoading } = base;
    const {
      list,
      sort,
      sortList,
      current,
      lightList,
      levelPopoverVisible,
      selectLevel,
      selectLight,
      lightPopoverVisible,
    } = this.state;
    return (
      <div className="gift-atlas-wrap noSelect">
        <div className="gift-atlas-header">
          <div className="sub-title">
            <span className="icon" />
            <span className="title">礼物图鉴</span>
          </div>

          <Popover
            rootClassName="daidai-popover-default gift-level-popover"
            trigger="click"
            placement="bottom"
            content={this.renderLightPopoverContent()}
          >
            <div className="sort-item level">
              <span className="sort-select-text">
                {selectLight != null ? lightList[selectLight] : '全部'}
              </span>
              <span className="icon">
                <label
                  className={Util.classNames(
                    'active',
                    lightPopoverVisible ? 'down' : 'up'
                  )}
                />
              </span>
            </div>
          </Popover>

          <Popover
            rootClassName="daidai-popover-default gift-level-popover"
            trigger="click"
            placement="bottom"
            content={this.renderPopoverContent()}
          >
            <div className="sort-item level">
              <span className="sort-select-text">
                {selectLevel?.title || '全部等级'}
              </span>
              <span className="icon">
                <label
                  className={Util.classNames(
                    'active',
                    levelPopoverVisible ? 'down' : 'up'
                  )}
                />
              </span>
            </div>
          </Popover>

          <ul className="sort-type noSelect">
            {sortList.map((item) => (
              <li
                key={item.type}
                className="sort-item"
                onClick={() => this.onChangeSort(item)}
              >
                <span>{item.name}</span>
                <span className="icon">
                  <label
                    className={Util.classNames('up', {
                      active:
                        sort.field === item.type && sort.order === 'ascend',
                    })}
                  />
                  <label
                    className={Util.classNames('down', {
                      active:
                        sort.field === item.type && sort.order === 'descend',
                    })}
                  />
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="gift-atlas-content">
          {list?.length ? (
            <Scrollbar
              ref={(el) => (this.giftAtlasScroll = el)}
              onScroll={this.handleScroll}
            >
              {list.map((item, index) => (
                <AchieveItem
                  key={item.giftId}
                  className="gift-atlas-item"
                  status={item.lightStatus}
                  cover={item.staticPic}
                  name={item.giftName}
                  num={item.giftNum}
                  onClick={() => this.onSelectCurrentGift(index)}
                >
                  {item?.backImgSmall && (
                    <div
                      className="item-bg"
                      style={{
                        backgroundImage: `url(${Util.transImgUrl(item.backImgSmall, '100x100')})`,
                      }}
                    />
                  )}
                  {item?.rarityImg && (
                    <div
                      className="gift-tag"
                      style={{
                        backgroundImage: `url(${Util.transImgUrl(item.rarityImg)})`,
                      }}
                    />
                  )}
                </AchieveItem>
              ))}
            </Scrollbar>
          ) : (
            !atlasLoading && (
              <DDEmpty description="暂无礼物" className="gift-atlas-empty" />
            )
          )}
        </div>

        <AtlasDetailsModal
          cRef={(el) => (this.atlasDetailsElement = el)}
          ds={ds}
          current={current}
          list={list}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(GiftAtlas);
